import styled from 'styled-components';

const HEADER_HEIGHT = 50;
const HERO_HEIGHT = 100;

export const AppWrapper = styled.div`
    padding-top: ${HEADER_HEIGHT + HERO_HEIGHT}px;
    width: 100%
`;
export const HeaderWrapper = styled.div`
    position:fixed;
    top:0;
    left: 0;
    width: 100%;
`;

export const Header = styled.div`
    /* position: fixed; */
    height: ${HEADER_HEIGHT}px;
    background-color: #222222;
    width: 100%;

`;
export const LogoWrapper = styled.img`
    padding: 7px;
`

export const HeroBanner = styled.div`
    background-color: #f1f1f1;
    height: ${HERO_HEIGHT}px;
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    padding: 30px 20px 10px 20px;
`;

export const SectionWrapper = styled.div`
padding: 20px;
`;

export const SectionTitle = styled.h3`
`;

export const SportsContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 10px
`
